'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.selectableReadOnlyInputWidget = function () {
	return mmWidgets.each(this, function () {
		const widget = this;

		widget.css('cursor', 'pointer');
		widget.on('input change', function (e) {
			const element = e.currentTarget;
			element.value = element.getAttribute('data-mm-val');
		});
		widget.on('click', function (e) {
			const element = e.currentTarget;
			if (element.setSelectionRange) {
				element.setSelectionRange(0, element.value.length);
			} else if (element.select) {
				element.select();
			}
		});
	});

};
